module.exports = __webpack_public_path__ + "img/member.d827e4c7.svg";